import { render, staticRenderFns } from "./PaydifyReturn.vue?vue&type=template&id=41848372&scoped=true"
import script from "./PaydifyReturn.vue?vue&type=script&lang=js"
export * from "./PaydifyReturn.vue?vue&type=script&lang=js"
import style0 from "./PaydifyReturn.vue?vue&type=style&index=0&id=41848372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41848372",
  null
  
)

export default component.exports